import React, { useId } from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/cn";

const BRANDS = [
  "Land Rover",
  "Range Rover",
  "BMW",
  "Mercedes-Benz",
  "Audi",
  "Jaguar",
];

/** Brands with a dedicated landing page — only used when `linked` is true. */
const BRAND_LINKS = {
  "Land Rover": "/land-rover-repair",
  "Range Rover": "/land-rover-repair",
  "BMW": "/european-auto-repair",
  "Mercedes-Benz": "/european-auto-repair",
  "Audi": "/european-auto-repair",
  Jaguar: "/jaguar-repair",
};

const chipClass =
  "inline-flex rounded-xl border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 shadow-sm transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:border-teal-600 hover:shadow-md sm:text-sm";

export default function VehicleBrandGrid({
  className,
  tone = "light",
  hideHeading = false,
  linked = false,
}) {
  const light = tone === "light";
  const headingId = useId();

  const rootProps = hideHeading
    ? {
        "aria-label": "Premium vehicle brands we service",
      }
    : {
        "aria-labelledby": headingId,
      };

  return (
    <section className={cn("", className)} {...rootProps}>
      {!hideHeading && (
        <h2
          id={headingId}
          className={cn(
            "text-xs font-semibold uppercase tracking-[0.18em]",
            light ? "text-slate-500" : "text-slate-400",
          )}
        >
          Brands we often work with
        </h2>
      )}
      <ul className={cn("flex flex-wrap gap-2", hideHeading ? "mt-0" : "mt-4")}>
        {BRANDS.map((name) => {
          const to = linked ? BRAND_LINKS[name] : undefined;
          return (
            <li key={name}>
              {to ? (
                <Link to={to} className={chipClass}>
                  {name}
                </Link>
              ) : (
                <span className={chipClass}>{name}</span>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
